function isGAEnabled() {
  return (
    process.env.NODE_ENV === 'production' && typeof window.ga === 'function'
  )
}

function ga(...args) {
  if (isGAEnabled()) {
    window.ga(...args)
  }
}

export function trackEvent(eventCategory, eventAction, eventLabel) {
  ga('send', {
    hitType: 'event',
    eventCategory,
    eventAction,
    eventLabel,
  })
}

// use this global only when necessary (outside of the bundle, e.g. contact form)
global.trackEvent = trackEvent



// WEBPACK FOOTER //
// ./src/app/ga.js